var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",
      class: _vm.switchClass
    },
    [
      _c(
        "div",
        {
          staticClass: "bootstrap-switch-container",
          on: {
            click: function($event) {
              _vm.triggerToggle()
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "bootstrap-switch-handle-on ",
              class: "bootstrap-switch-" + _vm.color
            },
            [
              _vm._t("on", [
                _vm._v("\n          " + _vm._s(_vm.onText) + "\n      ")
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("span", { staticClass: "bootstrap-switch-label" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "bootstrap-switch-handle-off bootstrap-switch-default"
            },
            [
              _vm._t("off", [
                _vm._v("\n          " + _vm._s(_vm.offText) + "\n      ")
              ])
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5168b938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5168b938","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Switch.vue
// module id = oSM6
// module chunks = 4